<template>
	<div class="page-birthday">
		<div class="box-login">
			<h3 :style="{ color: parceiro ? parceiroConfig.estilo.corSecundaria : 'var(primaryColor)' }">Entrar</h3>
			<p>
				{{ parceiroConfig.sessoes.customization == undefined || parceiroConfig.sessoes.customization.campos.confirmBirthday == undefined || parceiroConfig.sessoes.customization.campos.confirmBirthday.flgValidarDataNasc ? "Confirme sua data de nascimento para fazer seu login." : "Confirme que você não é um robô para fazer seu login." }}
			</p>
			<FormFields @save="next" @update:values="inputsValues = $event" :fields="fields" />
			<div class="box-buttons">
				<vue-recaptcha sitekey="6LcT3ZYaAAAAAFAwpV9WcdSbZUyuiEx9cC8xoF71" class="vue-recaptcha" :loadRecaptchaScript="true" @verify="verified = true"></vue-recaptcha>
				<ButtonDefault :color="parceiro ? parceiroConfig.estilo.corPrimaria : 'var(primaryColor)'" @click.native="next" text="Entrar" />
				<ButtonDefault :color="parceiro ? parceiroConfig.estilo.corSecundaria : 'var(secondaryColor)'" @click.native="esqueceu" text="Esqueceu o seu telefone?" v-if="parceiroConfig.sessoes.customization == undefined || parceiroConfig.sessoes.customization.campos.confirmBirthday == undefined || parceiroConfig.sessoes.customization.campos.confirmBirthday.flgValidarTelefone" />
			</div>
		</div>
	</div>
</template>

<script>
import FormFields from "../../components/FormFields";
import ButtonDefault from "../../components/buttons/ButtonDefault";
import globalMethods from "@/mixins/globalMethods";
import { mapActions, mapMutations, mapState } from "vuex";
import VueRecaptcha from "vue-recaptcha";
import moment from "moment";
export default {
	name: "ConfirmBirthday",
	components: { ButtonDefault, FormFields, VueRecaptcha },
	mixins: [globalMethods],
	data() {
		return {
			fields: [],
			identification: "",
			inputsValues: {}
		};
	},
	computed: {
		...mapState({
			parceiro: (state) => state.parceiro,
			parceiroConfig: (state) => state.parceiroConfig,
			pessoa: (state) => state.pessoa
		})
	},
	methods: {
		...mapMutations(["SET_LOADING", "SET_LOADING_MESSAGE", "CHANGE_MESSAGE_MODAL", "SET_CPF_CNPJ"]),
		...mapActions(["action_getCpfCnpj", "action_atualizar_data_nascimento", "action_salvar_etapa"]),
		next() {
			if (this.parceiroConfig.sessoes?.customization == undefined || this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday == undefined || this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday?.flgValidarDataNasc) {
				var reg = /(0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d/;
				if (!this.inputsValues.nascimento.match(reg)) {
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Por favor",
						message: `Insira uma data de nascimento válida.`,
						styleMessage: "danger"
					});
					return -1;
				} else if (moment().diff(moment(this.inputsValues.nascimento, "DD/MM/YYYY"), "years") < 18) {
					this.CHANGE_MESSAGE_MODAL({
						show: true,
						title: "Atenção",
						message: `É necessário ser maior de idade para continuar.`,
						styleMessage: "danger"
					});
					return -1;
				}
			}
			if (this.verified) {
				let dnString = this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday?.flgValidarDataNasc ? this.inputsValues.nascimento.split("/").reverse().join("/") : "";
				dnString = dnString.replace("/", "-").replace("/", "-");
				var emp_codigo = this.parceiro == "principal" ? "" : this.parceiroConfig.emp_codigo;

				this.SET_LOADING(true);
				this.SET_LOADING_MESSAGE("Confirmando os seus dados");

				this.action_salvar_etapa({
					cpfCnpj: this.removeMaskCharacters(this.identification),
					esn_fk_ets_codigo: 8,
					emp_codigo: this.parceiroConfig.emp_codigo
				}).then((response) => {});

				this.action_getCpfCnpj({
					cpfCnpj: this.removeMaskCharacters(this.identification),
					emp_codigo: emp_codigo,
					dataNascimento: this.inputsValues.nascimento,
					acceptCookies: localStorage.getItem("acceptCookies") !== undefined
				}).then((response) => {
					this.SET_CPF_CNPJ(this.removeMaskCharacters(this.identification));
					if (response.data.retorno && response.data.dados) {
						if (this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday?.flgValidarDataNasc) {
							if (Object.values(response.data.dados.empresa)[0].pessoa.dataNascimento === null) {
								this.action_atualizar_data_nascimento({
									pes_codigo: Object.values(response.data.dados.empresa)[0].pessoa.pes_codigo,
									data_nasc: Object.values(response.data.dados.empresa)[0].pessoa.dataNascimento,
									pes_sexo: Object.values(response.data.dados.empresa)[0].pessoa.sexo
								}).then((response) => {
									if (response.data.retorno) {
										console.log("Data atualizada.");
									} else {
										this.CHANGE_MESSAGE_MODAL({
											show: true,
											title: "Erro",
											message: `Erro ao atualizar a sua data de nascimento.`,
											styleMessage: "danger"
										});
										return -1;
									}
								});
							} else if (Object.values(response.data.dados.empresa)[0].pessoa.dataNascimento == dnString) {
								this.SET_CPF_CNPJ(this.removeMaskCharacters(this.identification));
							} else {
								this.CHANGE_MESSAGE_MODAL({
									show: true,
									title: "Data de nascimento errada",
									message: `Sua data de nascimento não condiz com a data de nascimento vinculada com este CPF/CNPJ`,
									styleMessage: "danger"
								});
								return -1;
							}
						}
						if (this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday?.flgValidarTelefone) {
							let tString = this.removeMaskCharacters(this.inputsValues.telefone);
							let flgTelefone = false;
							if (tString != undefined && tString != null && tString != "") {
								Object.values(response.data.dados.empresa)[0].pessoa.telefones.forEach((telefone) => {
									if (telefone.pef_fone == tString) {
										flgTelefone = true;
									}
								});
								if (!flgTelefone) {
									this.CHANGE_MESSAGE_MODAL({
										show: true,
										title: "Data de nascimento errada",
										message: `Telefone informado nào condiz com o telefone cadastrado neste CPF/CNPJ`,
										styleMessage: "danger"
									});
									return -1;
								}
							} else {
								this.CHANGE_MESSAGE_MODAL({
									show: true,
									title: "Atenção",
									message: `Digite um telefone válido`,
									styleMessage: "danger"
								});
								return -1;
							}
						}

						this.$router.push({ name: "AccordionTabs" });
						this.SET_LOADING_MESSAGE("");
						this.SET_LOADING(false);
					} else if (!response.data.retorno && (response.data.dados === "CPF/CNPJ não encontrado!" || response.data.dados === null)) {
						this.$router.push({
							name: "Register",
							params: {
								identification: this.removeMaskCharacters(this.identification)
							}
						});
					} else {
						this.CHANGE_MESSAGE_MODAL({
							show: true,
							title: "Erro",
							message: `Ocorreu um erro ao tentar encontrar o seu CPF`,
							styleMessage: "danger"
						});
						return -1;
					}
				});
			} else {
				this.CHANGE_MESSAGE_MODAL({
					show: true,
					title: "Por favor",
					message: `Conclua a verificação de segurança`,
					styleMessage: "danger"
				});
				return -1;
			}
		},
		esqueceu() {
			this.SET_LOADING(true);
			this.SET_LOADING_MESSAGE("Confirmando sua data de nascimento");
			this.$router.push({
				name: "ResetPhone",
				params: {
					identification: this.removeMaskCharacters(this.identification)
				}
			});
			this.SET_LOADING_MESSAGE("");
			this.SET_LOADING(false);
		}
	},
	created() {
		if (this.$route.params.identification) {
			this.identification = this.$route.params.identification;
			this.phoneNumber = this.$route.params.phoneNumber;
		} else {
			this.$router.push({ name: "LandPageParceiro" });
		}
	},
	mounted() {
		this.fields = [
			{
				variableName: "cpf_cnpj",
				fieldType: "TextFieldMask",
				label: "CPF",
				type: "text",
				cols: "12",
				maskFormat: "###.###.###-##",
				disabled: true,
				valueField: this.identification
			}
		];
		if (this.parceiroConfig.sessoes?.customization == undefined || this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday == undefined || this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday?.flgValidarDataNasc) {
			var campoDN = {
				variableName: "nascimento",
				fieldType: "TextFieldMask",
				label: "Data nascimento",
				type: "text",
				cols: "12",
				maskFormat: "##/##/####"
			};
			this.fields.push(campoDN);
		}
		if (this.parceiroConfig.sessoes?.customization == undefined || this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday == undefined || this.parceiroConfig.sessoes?.customization?.campos?.confirmBirthday?.flgValidarTelefone) {
			var campoT = {
				variableName: "telefone",
				fieldType: "TextFieldMask",
				label: "Telefone",
				type: "text",
				cols: "12",
				maskFormat: "(##) #####-####",
				valueField: this.phoneNumber
			};
			this.fields.push(campoT);
		}
		window.fbq("trackCustom", "Confirmação de CPF");
	}
};
</script>

<style scoped>
.page-birthday {
	min-height: 100vh;
	flex: 1;
	padding: 50px;
	display: flex;
	justify-content: center;
	align-items: center;
}

.page-birthday h3 {
	text-align: center;
	color: var(--secondaryColor);
	font-size: 32px;
	font-family: Montserrat-Bold;
	margin-bottom: 5px;
}

.page-birthday p {
	text-align: center;
	font-size: 14px;
	line-height: 24px;
	font-family: Roboto;
	font-weight: normal !important;
	margin-bottom: 30px;
}

.box-login {
	width: 400px;
}

.vue-recaptcha {
	align-items: center;
	justify-content: center;
	display: flex;
}
.box-buttons {
	display: flex;
	flex-direction: column;
	margin-top: 30px;
	padding: 0 15px;
	gap: 20px;
}
</style>
